import React from "react";
import { OptionDropdown } from "@/components/ui/OptionDropdown";
import type { DropdownOption } from "@/components/ui/OptionDropdown";
import type { ClientStatus } from "@/types";
import {
  CLIENT_STATUS_CONFIG,
  INLINE_SWITCHABLE_STATUSES,
} from "../clientStatusConfig";

interface ClientStatusBadgeProps {
  status: ClientStatus;
  /**
   * Provide to enable the dropdown affordance. Only flips between ACTIVE and
   * PROPOSAL — archive/unarchive lives in the row's action menu.
   */
  onStatusChange?: (status: ClientStatus) => void;
  disabled?: boolean;
  align?: "left" | "right";
}

function toOption(status: ClientStatus): DropdownOption<ClientStatus> {
  const cfg = CLIENT_STATUS_CONFIG[status];
  return {
    value: status,
    label: cfg.label,
    bg: cfg.bg,
    text: cfg.text,
    dot: cfg.dot,
  };
}

const SWITCHABLE_OPTIONS = INLINE_SWITCHABLE_STATUSES.map(toOption);
const ALL_OPTIONS = (
  Object.keys(CLIENT_STATUS_CONFIG) as ClientStatus[]
).map(toOption);

export const ClientStatusBadge: React.FC<ClientStatusBadgeProps> = ({
  status,
  onStatusChange,
  disabled = false,
  align = "left",
}) => {
  // Archived clients render a static pill — restoration goes through the row
  // action menu, not the badge dropdown.
  const isInteractive = !!onStatusChange && status !== "ARCHIVED";

  return (
    <OptionDropdown
      value={status}
      options={isInteractive ? SWITCHABLE_OPTIONS : ALL_OPTIONS}
      onChange={isInteractive ? onStatusChange : undefined}
      disabled={disabled}
      align={align}
    />
  );
};
